import { Component, input } from '@angular/core'
import { IllustrationComponent, PageComponent } from '@ftr/foundation'

@Component({
  selector: 'ftr-under-construction',
  templateUrl: './under-construction.component.html',
  styleUrl: './under-construction.component.css',
  imports: [IllustrationComponent, PageComponent],
})
export class UnderConstructionComponent {
  readonly title = input('Under construction')
  readonly message = input('This page is not available yet. Please check back soon.')
}
